"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationInsightsEventBaseType = exports.ApplicationInsightsAvailabilityBaseType = exports.ApplicationInsightsPageViewBaseType = exports.ApplicationInsightsExceptionBaseType = exports.ApplicationInsightsMessageBaseType = exports.ApplicationInsightsEventName = exports.ApplicationInsightsAvailabilityName = exports.ApplicationInsightsPageViewName = exports.ApplicationInsightsExceptionName = exports.ApplicationInsightsMessageName = exports.MicrosoftClientIp = exports.ApplicationInsightsCustomEventName = exports.ApplicationInsightsBaseType = exports.AzureMonitorSampleRate = exports.DependencyTypes = exports.packageVersion = exports.TIME_SINCE_ENQUEUED = exports.ENQUEUED_TIME = exports.MS_LINKS = void 0;
/**
 * AI MS Links.
 * @internal
 */
exports.MS_LINKS = "_MS.links";
/**
 * AI enqueued time attribute.
 * @internal
 */
exports.ENQUEUED_TIME = "enqueuedTime";
/**
 * AI time since enqueued attribute.
 * @internal
 */
exports.TIME_SINCE_ENQUEUED = "timeSinceEnqueued";
/**
 * AzureMonitorTraceExporter version.
 * @internal
 */
exports.packageVersion = "1.0.0-beta.39";
var DependencyTypes;
(function (DependencyTypes) {
    DependencyTypes["InProc"] = "InProc";
    DependencyTypes["QueueMessage"] = "Queue Message";
    DependencyTypes["Sql"] = "SQL";
    DependencyTypes["Http"] = "Http";
    DependencyTypes["Grpc"] = "GRPC";
    DependencyTypes["Wcf"] = "WCF Service";
})(DependencyTypes || (exports.DependencyTypes = DependencyTypes = {}));
exports.AzureMonitorSampleRate = "microsoft.sample_rate";
exports.ApplicationInsightsBaseType = "_MS.baseType";
exports.ApplicationInsightsCustomEventName = "microsoft.custom_event.name";
exports.MicrosoftClientIp = "microsoft.client.ip";
exports.ApplicationInsightsMessageName = "Microsoft.ApplicationInsights.Message";
exports.ApplicationInsightsExceptionName = "Microsoft.ApplicationInsights.Exception";
exports.ApplicationInsightsPageViewName = "Microsoft.ApplicationInsights.PageView";
exports.ApplicationInsightsAvailabilityName = "Microsoft.ApplicationInsights.Availability";
exports.ApplicationInsightsEventName = "Microsoft.ApplicationInsights.Event";
exports.ApplicationInsightsMessageBaseType = "MessageData";
exports.ApplicationInsightsExceptionBaseType = "ExceptionData";
exports.ApplicationInsightsPageViewBaseType = "PageViewData";
exports.ApplicationInsightsAvailabilityBaseType = "AvailabilityData";
exports.ApplicationInsightsEventBaseType = "EventData";
//# sourceMappingURL=applicationinsights.js.map